import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import styles from 'components/form/form-style'

const Hint = ({ children, theme, isSecondary }) => {
  const classes = styles(theme)

  return (
    <p className={classNames(classes.hint, { [classes.hintSecondary]: isSecondary })}>
      <span className={classNames('fal', 'fa-info-circle', classes.hintIcon)} />
      {children}
    </p>
  )
}

Hint.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  isSecondary: PropTypes.bool,
}

export default withTheme(Hint)
